import CGU from '../../components/CGU/CGU.component';
import MentionsLegales from '../../components/mentions-legales/mentions-legales-component';
import { mentionsLegalesText } from '../../components/mentions-legales/text-mentions-legales';
import PageHeader from '../../components/page-header/page-header.component';
import '../../styles/legal-page.styles.scss';

const LegalesInfos = () => {
  return (
    <div className="legal-page">
      <PageHeader overline="Informations" title={mentionsLegalesText.title} />
      <MentionsLegales />
      <CGU />
    </div>
  );
};

export default LegalesInfos;
